import { Field, ErrorMessage } from 'formik';
import React, { PropsWithChildren } from 'react';
import style from './textarea.module.scss';

// Use TextareaHTMLAttributes for typing
export const Textarea = (
  props: PropsWithChildren<React.TextareaHTMLAttributes<HTMLTextAreaElement>>
) => {
  return (
    <>
      <Field component="textarea" className={style.wrapper} {...props} />
      <div className={style.errorMessage}>
        <ErrorMessage name={props?.name ?? ''} />
      </div>
    </>
  );
};
